import { ReactElement, useContext } from "react";
import { Dialog, Button } from "@justworkshr/milo-core";
import useGetAuthorizeUrl from "pages/register/hooks/useGetAuthorizeUrl";
import AuthTransactionContext from "pages/register/contexts/AuthTransactionContext";
import getAuthorizeParams from "pages/register/util/getAuthorizeParams";

const titleCopy = "You've been logged out due to inactivity";
const dialogCopy =
  "Use the username and password you just created to get back in and finish creating your account.";
const buttonCopy = "Log in";

const ExpiredTransactionModal = (): ReactElement => {
  const { data: authorizeData, isLoading } = useGetAuthorizeUrl({
    ...getAuthorizeParams(),
  });
  const { completeRegistration } = useContext(AuthTransactionContext);

  const onLogInHandler = () => {
    if (!authorizeData) return;
    completeRegistration(authorizeData.redirectUrl);
  };

  return (
    <Dialog
      isOpen={true}
      title={titleCopy}
      showCloseButton={false}
      primaryButton={
        <Button loading={isLoading} onClick={onLogInHandler}>
          {buttonCopy}
        </Button>
      }
    >
      {dialogCopy}
    </Dialog>
  );
};

export default ExpiredTransactionModal;
